const Questions = ({
  index,
  input,
  onChange,
  onRemove,
}) => {

  const updateOption = (optId, patch) => {
    onChange(input.id, {
      options: input.options.map((o) =>
        o.id === optId
          ? { ...o, ...patch }
          : patch.isAnswer
          ? { ...o, isAnswer: false }
          : o
      ),
    });
  };

  const addOption = () => {
    if (input.options.length >= 5) return;
    onChange(input.id, {
      options: [
        ...input.options,
        {
          id: Math.random().toString(36),
          option: "",
          isAnswer: false,
          orderBy: input.options.length + 1,
        },
      ],
    });
  };

  const removeOption = (optId) => {
    onChange(input.id, {
      options: input.options
        .filter((o) => o.id !== optId)
        .map((o, i) => ({ ...o, orderBy: i + 1 })),
    });
  };

  return (
    <>
      {/* Question header */}
      <div className="flex justify-between items-center mb-2 mt-4">
        <label className="font-medium text-base">
          Question No: {index + 1}
        </label>

        {index > 0 && (
          <button
            onClick={() => onRemove(input.id)}
            className="text-red-600 text-base hover:underline"
          >
            Remove
          </button>
        )}
      </div>

      {/* Question input */}
      <input
        type="text"
        placeholder="Question"
        value={input.question}
        onChange={(e) =>
          onChange(input.id, { question: e.target.value })
        }
        className="w-full border rounded-md px-3 py-2 mb-4 h-14
          dark:bg-slate-800 dark:border-slate-700"
      />

      {/* Options */}
    <div className="space-y-3">
  {input.options.map((opt, i) => (
    <div key={opt.id} className="flex items-center gap-3">
      
      {/* Input with checkbox inside */}
      <div
        className="
    flex items-center w-full h-14
    border rounded-md overflow-hidden
    bg-white dark:bg-slate-900
    dark:border-slate-700
  "
      >
        {/* Checkbox section */}
        <div
          className="flex items-center justify-center
          h-full px-4
          border-r dark:border-slate-700"
        >
          <input
            type="checkbox"
            checked={opt.isAnswer}
            onChange={(e) =>
              updateOption(opt.id, { isAnswer: e.target.checked })
            }
            className="h-4 w-4"
          />
        </div>

        {/* Text input */}
        <input
          type="text"
          placeholder={`Option ${i + 1}`}
          value={opt.option}
          onChange={(e) =>
            updateOption(opt.id, { option: e.target.value })
          }
          className="flex-1 h-full px-3
          outline-none bg-transparent
          dark:text-white"
        />
      </div>

      {/* Remove button */}
      {input.options.length > 2 && (
      <button
  onClick={() => removeOption(opt.id)}
  className="
    h-6 w-6
    flex items-center justify-center
    rounded-full
    text-red-500
    hover:bg-red-100
    hover:text-red-600
    transition
  "
  title="Remove option"
>
  ✕
</button>

      )}
    </div>
  ))}
</div>


      {/* Footer */}
      <div className="flex flex-wrap justify-between items-center gap-4 mt-4">
   <label
  className="
    flex items-center gap-2 text-base
    border border-gray-300 dark:border-slate-600
    rounded-md
    px-3 py-2
    cursor-pointer
    hover:bg-gray-50 dark:hover:bg-slate-800
  "
>
  <input
    type="checkbox"
    checked={input.hasGraceMark}
    onChange={(e) =>
      onChange(input.id, { hasGraceMark: e.target.checked })
    }
    className="h-4 w-4"
  />
  <span>Has Grace Mark?</span>
</label>



        <div className="flex items-center gap-4 text-base">


      <button
  onClick={addOption}
  disabled={input.options.length >= 5}
  className="
    px-3 py-1 rounded-md border border-gray-300
    hover:bg-gray-100 dark:hover:bg-slate-800
    disabled:opacity-50
    disabled:pointer-events-none
    disabled:cursor-not-allowed
  "
>
  Add Option
</button>
        </div>
      </div>

      <hr className="my-4" />
    </>
  );
};

export default Questions;
